module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/68b3e3b9a788c27ad257034e36d2a778.png";